// extracted by mini-css-extract-plugin
export var itemGrid = "serializers-module--itemGrid--f03a2";
export var itemGridContainer = "serializers-module--itemGridContainer--ca166";
export var textStyleLargeTitle = "serializers-module--text-style-large-title--935c1";
export var textStyleLargestTitle = "serializers-module--text-style-largest-title--89326";
export var textStyleMediumTitle = "serializers-module--text-style-medium-title--c0322";
export var textStyleSmallTitle = "serializers-module--text-style-small-title--d888d";
export var withColumnLayout = "serializers-module--withColumnLayout--cf1f0";